import { createAsyncThunk, createSlice, Dictionary } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { PriceDefiningAnswer } from 'Douleutaras/redux/data/v2/bids/types';

const BID_PRICE_DEFINE_ANSWERS_ENDPOINT = 'api/public/bid/bid_id/price_defining_questions';

interface BidPriceDefineAnswersParams {
  bidId: string;
  source?: string; // 'pro' | 'customer'
}

export const getPriceDefineAnswers = createAsyncThunk<
  { result: Array<PriceDefiningAnswer>; identifier: string },
  BidPriceDefineAnswersParams
  >(
  'bid/priceDefineAnswers/get',
  async ({ bidId, source = 'pro' }, api) => {
    const response = await makeRequest(BID_PRICE_DEFINE_ANSWERS_ENDPOINT.replace('bid_id', bidId), {
      additionalGetParams: {
        source
      }
    })(api);

    return {
      result: response?.data,
      identifier: `${bidId}`
    };
  }
);

export const bidPriceDefineAnswersSlice = createSlice({
  name: 'bidPriceDefineAnswers',
  initialState: {
    answers: {}
  } as { answers: Dictionary<Array<PriceDefiningAnswer>> },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPriceDefineAnswers.fulfilled, (state, action) => {
      state.answers = {
        ...state.answers,
        [action.payload.identifier]: action.payload.result
      };
    });
  }
});
